export default class UserGuideArticleConfig {
  constructor({ name, title, icon }) {
    this.name = name;
    this.title = title;
    this.icon = icon;
  }
}
